/**
 * signUpAttribution: what every account creation call carries about how the
 * shopper arrived. One helper, spread into each call in redux/apiCalls.js, so
 * a new door (or a new kind of link) is added in one place.
 *
 *   referralCode       a friend's invite link (utils/referralCode.js)
 *   groupBasketToken   an "Order together" link (utils/groupBasketLink.js)
 *
 * Each field is absent when there is nothing to carry. The server attributes
 * them only when the call creates the account, and never fails a sign up over
 * them.
 */
import { referralCodeField } from "./referralCode";
import { groupBasketTokenField } from "./groupBasketLink";

export const signUpAttributionFields = () => ({
  ...referralCodeField(),
  ...groupBasketTokenField(),
});

export default signUpAttributionFields;
